import { z } from 'zod';
import { CONTENT_ID_PATTERN } from './profile.js';
/**
 * Магазин (SPEC.md, раздел 18): только косметика. В MVP — каталог и предпросмотр без оплаты;
 * предметы-награды за боссов выдаются и надеваются. Каталог и владение — с сервера.
 */
export const SHOP_CATEGORIES = [
    'microbes',
    'vessels',
    'capsules',
    'labs',
    'effects',
    'profile',
];
/** Слоты надетых предметов: скин каждого вида микробов, сосуда и капсул. */
export const COSMETIC_SLOTS = ['microbe-0', 'microbe-1', 'microbe-2', 'vessel', 'capsule'];
/** Вид предмета — идентификатор рисунка клиента («santa», «aquarium», «candy»). */
export const COSMETIC_LOOKS = ['santa', 'shades', 'aquarium', 'snowglobe', 'candy'];
/** Надеть предмет в слот или снять (itemId = null). */
export const equipSchema = z.strictObject({
    slot: z.enum(COSMETIC_SLOTS),
    itemId: z.string().regex(CONTENT_ID_PATTERN).nullable(),
});
//# sourceMappingURL=shop.js.map